module.exports = __webpack_public_path__ + "static/auto_policy_updates_desktop-061bdb686cf4e337a81ecb3ee2e419b3.png";